export const toOption = (
  label: string,
  value?: string,
  description?: string
): SelectOptionWithDescription => ({
  label,
  value: value || label,
  description,
});

export type SelectOptionWithDescription = {
  description: string | undefined;
  label: string;
  value: string;
};
